import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ValueContainer = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver20};
    border-radius: 8px;
    padding: 4px 18px;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: ${theme.colors.primary70};
    }

    @media (max-width: 992px) {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const Button = styled.button`
  ${({ theme, disabled }) => css`
    width: 32px;
    height: 32px;

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${theme.colors.neutralSilver5};
    border: 1px solid ${theme.colors.neutralSilver20};
    border-radius: 8px;

    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }

    svg {
      color: ${disabled
        ? theme.colors.neutralSilver30
        : theme.colors.neutralSilver70};
    }

    @media (max-width: 992px) {
      width: 48px;
      height: 48px;
    }
  `}
`;
